import { useState } from 'react';
import Modal from '../../common/Modal';

function PracticeReserveHowto() {
  const [isVideoModalOpen, setIsVideoModalOpen] = useState<boolean>(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setIsVideoModalOpen(true)}
        className="btn btn-info"
        style={{ fontSize: '14px' }}
      >
        <i className="fas fa-play-circle" style={{ marginRight: '6px' }}></i>
        予約方法はこちら
      </button>

      <Modal
        isDispModal={isVideoModalOpen}
        setIsDispModal={setIsVideoModalOpen}
        isDispClose={true}
        isBackClose={true}
        modalWidth="800px"
        comp={
          isVideoModalOpen && (
            <div style={{ backgroundColor: '#fff', borderRadius: '8px' }}>
              <iframe
                width="100%"
                src="https://www.youtube.com/embed/8G1-yJwFMpU?autoplay=1"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                style={{ aspectRatio: '16 / 9', display: 'block' }}
              ></iframe>
            </div>
          )
        }
      />
    </>
  );
}

export default PracticeReserveHowto;
